import React, { useState } from 'react';
import { Box, ThemeProvider } from '@mui/material';
import LandingPage from '../landingPage';
import { SmartFeedDashboard, smartFeedTheme, SubscriptionProvider } from '../../Components/SmartFeed';
import HomeToggleHeader from '../../Components/HomeToggleHeader';

const DEFAULT_HOME_VIEW = 'smartfeed';

const HomePage = () => {
  const [view, setView] = useState(DEFAULT_HOME_VIEW);

  // Subscription: fully driven by DB. Users without a subscription (has_subscription false from
  // /api/user/user/) are blocked at App level and never reach HomePage. Users with a subscription
  // are not shown any popup here; they can use NavBar → Abonnement (/subscription) to change plan.

  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: view === 'smartfeed' ? '#0b0e1a' : '#00001d' }}>
      <HomeToggleHeader view={view} onViewChange={handleViewChange} />
      
      <Box sx={{ position: 'relative' }}>
        {view === 'classic' ? (
          <LandingPage />
        ) : (
          <ThemeProvider theme={smartFeedTheme}>
            <SubscriptionProvider>
              <SmartFeedDashboard />
            </SubscriptionProvider>
          </ThemeProvider>
        )}
      </Box>
    </Box>
  );
};

export default HomePage;
